/* istanbul ignore file */
/* it has been tested in handyman */

import * as React from 'react';

/**
 * source file: https://github.agodadev.io/agoda-front-end/react-handyman/blob/master/src/utils/stringFormatter/stringFormatter.ts
 */
export module StringFormatter {
    export const format = (template: string, ...args: (string | number)[]): string => {
        if (!template) return handleInvalidTemplate('format', '') as string;

        return String(template).replace(/\{([^{}]+)\}/g, (match, key: any) => (args[key] != null ? args[key] : key));
    };

    export const formatToJsx = (
        template: string,
        ...args: (string | number | React.ReactNode)[]
    ): React.ReactNode[] => {
        if (!template) return handleInvalidTemplate('formatToJsx', []) as React.ReactNode[];

        const mapper = (item: string, index: number) => {
            const current = Number(item);
            const shouldBeReplaced = !containsWhiteSpace(item) && current < args.length;

            if (shouldBeReplaced) {
                const substitute = args[current];
                const isString = typeof substitute === 'string' || substitute instanceof String;
                const isNumber = typeof substitute === 'number' || substitute instanceof Number;

                return isString || isNumber
                    ? React.createElement('span', { key: index }, (substitute as string | number).toString())
                    : substitute;
            }

            return React.createElement('span', { key: index }, item);
        };

        return replace(template, mapper);
    };

    const replace = (template: string, fn: (item: string, index: number) => any) => {
        return template.split(/[{}]/g).filter(Boolean).map(fn);
    };

    const handleInvalidTemplate = (functionName: string, defaultValue: string | React.ReactNode[]) => {
        if (console && typeof console.error === 'function') {
            console.error(`Invalid template argument for StringFormatter ${functionName}`);
        }
        return defaultValue;
    };

    const containsWhiteSpace = (string: string): boolean => {
        return /\s/.test(string);
    };
}
